import React, { Component } from 'react';
import { Container, Row } from 'reactstrap';

//Import Components
import SectionTitle from '../../components/common/section-title';

//Import Team Box
import TeamBox from './team-box';

//Import Images
import kirkduchesne2 from '../../assets/images/team/kirkduchesne2.png';
import summerduchesne from '../../assets/images/team/summerduchesne.webp';

class OurTeam extends Component {
	state = {
		members: [
			{
				id: 1,
				name: 'Kirk Duchesne',
				image: kirkduchesne2,
				post: 'Chief Executive Officer/Founder',
				desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.',
				socials: [
					{ class: 'bg-linkedin', icon: 'ti-linkedin', link: 'linkedin-kirk' },
				],
			},
			{
				id: 2,
				name: 'Summer Duchesne',
				image: summerduchesne,
				post: 'Executive Vice President/Co-Founder',
				desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.',
				socials: [
					{
						class: 'bg-linkedin',
						icon: 'ti-linkedin',
						link: 'linkedin-summer',
					},
				],
			},
		],
	};
	render() {
		return (
			<React.Fragment>
				<section className="section bg-lightgray" id="team">
					<Container>
						<SectionTitle title="Our Team" />
						<Row className="justify-content-center">
							<TeamBox members={this.state.members} />
						</Row>
					</Container>
				</section>
			</React.Fragment>
		);
	}
}

export default OurTeam;
